import React from "react";
import { Link } from "react-router-dom";
import SectionHeading from "./SectionHeading";
import { LANDING } from "@/constants/testIds";
import { PERSPECTIVES } from "@/data/perspectives";

const Perspectives = () => {
  return (
    <section
      id="perspectives"
      data-testid={LANDING.perspectives}
      className="relative py-32 lg:py-44 border-t border-[var(--kr-line-soft)]"
    >
      <div className="max-w-[1480px] mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-16 items-end mb-20">
          <div className="lg:col-span-8">
            <SectionHeading
              index="10"
              label="Perspectives"
              title={
                <>
                  Field notes on{" "}
                  <span className="italic text-[var(--kr-gold)]">private</span>{" "}
                  industrial capital.
                </>
              }
            />
          </div>
          <div className="lg:col-span-4 lg:text-right">
            <Link
              to="/perspectives"
              data-testid={LANDING.perspectivesAll}
              className="kr-link font-mono-label text-[11px]"
            >
              All Perspectives →
            </Link>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-0 border-t border-l border-[var(--kr-line)]">
          {PERSPECTIVES.slice(0, 4).map((a, i) => (
            <Link
              key={a.slug}
              to={`/perspectives/${a.slug}`}
              data-testid={`${LANDING.perspectiveCardPrefix}${i}`}
              className="group p-10 lg:p-12 border-r border-b border-[var(--kr-line)] cursor-pointer transition-colors duration-500 hover:bg-[rgba(201,169,110,0.025)] block"
            >
              <div className="flex items-center justify-between mb-10">
                <span className="font-mono-label text-[10px] text-[var(--kr-gold)]">
                  {a.tag}
                </span>
                <span className="font-mono-label text-[10px] text-[var(--kr-text-muted)]">
                  {a.date}
                </span>
              </div>
              <h3 className="font-serif-display text-[1.8rem] lg:text-[2.05rem] leading-[1.18] text-[var(--kr-text)] mb-6 group-hover:text-[var(--kr-gold)] transition-colors duration-500 max-w-[28ch]">
                {a.title}
              </h3>
              <p className="text-[var(--kr-text-muted)] text-[15px] leading-[1.75] mb-10 max-w-[58ch]">
                {a.excerpt}
              </p>
              <div className="flex items-center justify-between">
                <span className="font-mono-label text-[10px] text-[var(--kr-text-muted)]">
                  {a.minutes}
                </span>
                <span
                  className="font-mono-label text-[11px] text-[var(--kr-gold)] inline-flex items-center gap-3"
                  aria-hidden
                >
                  Read Paper{" "}
                  <span className="block w-8 h-px bg-[var(--kr-gold)] transition-all duration-500 group-hover:w-12" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Perspectives;
